import { render, staticRenderFns } from "./FindPwd.vue?vue&type=template&id=5a610ca5&scoped=true"
import script from "./FindPwd.vue?vue&type=script&lang=js"
export * from "./FindPwd.vue?vue&type=script&lang=js"
import style0 from "./FindPwd.vue?vue&type=style&index=0&id=5a610ca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a610ca5",
  null
  
)

export default component.exports